import React, { useEffect, useRef } from "react";
import { CheckedIconColored, MenuDownIcon } from "assests/GmsIcons";
import { HotSellerPeriodType, SeasonalYearPeriodType } from "../../Types";

type PeriodTypes = HotSellerPeriodType | SeasonalYearPeriodType;

function PeriodDropdown<T extends PeriodTypes>({
    isOpen,
    selectedPeriod,
    onToggle,
    onSelect,
    periods,
}: {
    isOpen: boolean;
    selectedPeriod: T;
    onToggle: () => void;
    onSelect: (period: T) => void;
    periods: readonly T[]
}) {
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                onToggle();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onToggle]);

    return (
        <div className="tw-relative tw-mt-2" ref={dropdownRef}>
            <div
                onClick={onToggle}
                className={`tw-w-48 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-outline tw-outline-1 tw-outline-offset-[-1px] ${isOpen ? 'tw-outline-blue-950 -[1.40px] tw-outlinetw-outline-offset-[-1.40px]' : 'tw-outline-gray-200'
                    } tw-inline-flex tw-justify-start tw-items-center tw-gap-2.5 tw-cursor-pointer`}
            >
                <div className="tw-flex-1 tw-justify-start tw-text-blue-950 tw-text-sm tw-font-semibold tw-leading-tight">
                    {selectedPeriod}
                </div>
                <MenuDownIcon />
            </div>

            {isOpen && (
                <div className="tw-absolute tw-z-10 tw-left-0 tw-top-full tw-w-48 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)] tw-inline-flex tw-flex-col tw-justify-start tw-items-start">
                    {periods.map((period, index) => (
                        <div
                            key={period as string}
                            onClick={() => onSelect(period)}
                            className={`
                                tw-self-stretch tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white 
                                tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-zinc-200 
                                tw-inline-flex tw-justify-start tw-items-center tw-gap-2.5
                                tw-cursor-pointer
                                ${index === 0 ? 'tw-rounded-tl-[3px] tw-rounded-tr-[3px]' : ''}
                                ${index === periods.length - 1 ? 'tw-rounded-bl tw-rounded-br' : ''}
                            `}
                        >
                            <div className={`
                                ${selectedPeriod === period ? 'tw-w-36 tw-font-semibold' : 'tw-flex-1'} 
                                tw-justify-start tw-text-blue-950 tw-text-sm tw-leading-tight
                            `}>
                                {period}
                            </div>
                            {selectedPeriod === period && (
                                <CheckedIconColored />
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default PeriodDropdown;